var React = require('react');

function Financial (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"1.5","y":"11.5","width":"4","height":"6","rx":"0.5","stroke":"#3F3F3F","key":0}),React.createElement("rect",{"x":"8.5","y":"6.5","width":"4","height":"11","rx":"0.5","stroke":"#3F3F3F","key":1}),React.createElement("rect",{"x":"15.5","y":"2.5","width":"4","height":"15","rx":"0.5","stroke":"#3F3F3F","key":2})]);
}

Financial.defaultProps = {"style":{"marginBottom":"0.2em"},"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Financial;

Financial.default = Financial;
